import { api } from '@marketplace-web/core-api/core-api-client-util'

import { RequestFurtherHelpArgs } from '../types/further-help'

export const requestFurtherHelp = (args: RequestFurtherHelpArgs) =>
  api.post(`/users/${args.userId}/msg_threads/${args.conversationId}/request_further_help`, {
    help_center_session_id: args.helpCenterSessionId,
  })
